import template from './quantity-freeshipping.html';
export var QuantityFreeshippingComponent = {
    template: template,
    bindings: {
        item: '<',
        onUpdate: '&',
        limitedStock: '<'
    },
    controller: /** @class */ (function () {
        function QuantityFreeshippingComponent(CartService) {
            'ngInject';
            this.clearQuantity = function () {
                this.item.onHandQuantity = this.item.quantity;
            };
            this.CartService = CartService;
        }
        QuantityFreeshippingComponent.prototype.$onOnit = function () {
            this.showUpdateBtn = false;
            this.originalQuantity = 0;
        };
        QuantityFreeshippingComponent.prototype.$onChanges = function (changes) {
            if (changes.item) {
                this.item = Object.assign({}, this.item);
                this.item.quantity = (this.item.quantity) ? this.item.quantity : 1;
                this.originalQuantity = this.item.quantity;
            }
        };
        QuantityFreeshippingComponent.prototype.decrement = function () {
            this.item.quantity = this.item.quantity ? parseInt(this.item.quantity, 10) : 0;
            var quantity = this.item.quantity || this.quantityAdjustForm.quantity.$$rawModelValue;
            var minimumSaleQuantity = this.item.minimumSaleQuantity;
            if (minimumSaleQuantity === 0) {
                quantity -= 1;
            }
            else {
                quantity = quantity % minimumSaleQuantity === 0 ?
                    quantity - minimumSaleQuantity :
                    quantity - (quantity % minimumSaleQuantity);
            }
            this.item.quantity = quantity;
            this.showUpdateBtn = this.originalQuantity !== this.item.quantity;
            if (this.showUpdateBtn)
                this.updateQuantity();
        };
        QuantityFreeshippingComponent.prototype.increment = function () {
            this.item.quantity = this.item.quantity ? parseInt(this.item.quantity, 10) : 0;
            var quantity = this.item.quantity || this.quantityAdjustForm.quantity.$$rawModelValue;
            var minimumSaleQuantity = this.item.minimumSaleQuantity;
            var onHandQuantity = this.item.onHandQuantity;
            if ((quantity < this.limitedStock) || (quantity < (this.item.isOnVendorBackOrder ? this.item.onHandQuantity : 9999))) {
                quantity += 1;
            }
            else {
                if ((quantity + minimumSaleQuantity) > onHandQuantity) {
                    quantity = quantity % minimumSaleQuantity === 0 ?
                        quantity + minimumSaleQuantity :
                        quantity + (minimumSaleQuantity - quantity);
                }
                else {
                    quantity += minimumSaleQuantity;
                }
            }
            this.item.quantity = quantity;
            this.showUpdateBtn = this.originalQuantity !== this.item.quantity;
            if (this.showUpdateBtn)
                this.updateQuantity();
        };
        QuantityFreeshippingComponent.prototype.updateQuantity = function () {
            this.showUpdateBtn = false;
            this.onUpdate({
                $event: {
                    item: this.item
                }
            });
        };
        QuantityFreeshippingComponent.prototype.updateOnHandQuantity = function () {
            var defaultInventory = this.CartService.getDefaultInventory(this.item.inventory);
            if (this.item.quantity === null || this.item.quantity === undefined)
                this.item.quantity = this.item.onHandQuantity;
            else if (this.item.quantity > defaultInventory.stock && ((defaultInventory && defaultInventory.vendorBackOrder) || this.item.isDiscontinued)) {
                this.item.quantity = defaultInventory.stock;
            }
            else if (this.item.quantity > this.item.onHandQuantity && (defaultInventory && defaultInventory.vendorBackOrder)) {
                this.item.quantity = this.item.onHandQuantity;
            }
            this.updateQuantity();
        };
        return QuantityFreeshippingComponent;
    }())
};
//# sourceMappingURL=quantity-freeshipping.component.js.map